'use client';

import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

interface ConfigValue {
  /** ComusFlow account app (login / signup), e.g. https://app.comusflow.com */
  appUrl: string;
  /** ComusFlow marketing site (venues who want to publish), e.g. https://www.comusflow.com */
  comusflowUrl: string;
}

const ConfigContext = createContext<ConfigValue>({
  appUrl: 'https://app.comusflow.com',
  comusflowUrl: 'https://www.comusflow.com',
});

interface ConfigProviderProps {
  appUrl: string;
  comusflowUrl: string;
  children: ReactNode;
}

export function ConfigProvider({ appUrl, comusflowUrl, children }: ConfigProviderProps) {
  return (
    <ConfigContext.Provider value={{ appUrl, comusflowUrl }}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig(): ConfigValue {
  return useContext(ConfigContext);
}
